module.exports = __webpack_public_path__ + "img/abehirosuke@3x.e552ca2c.png";